import classNames from 'classnames';

import Image from '../partials/Image';
import CardTitleTypography from '../typography/CardTitle';
import SurtitleTypography from '../typography/Surtitle';
import VerticalCard from './VerticalCard';

import styles from '../../styles/cards/block-default-card.module.css';

interface BlockDefaultCardProps extends Card {
    className?: string | null;
}

function BlockDefaultCard({
    title = null,
    price = null,
    url = null,
    image = null,
    className,
}: BlockDefaultCardProps) {
    return (
        <VerticalCard
            href={url}
            external
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            thumbnail={
                image !== null ? (
                    <Image
                        media={image}
                        size="medium"
                        className={styles.image}
                        pictureClassName={styles.picture}
                    />
                ) : null
            }
            thumbnailRatio={1}
            labelClassName={styles.label}
            thumbnailClassName={styles.thumbnail}
        >
            {title !== null ? (
                <CardTitleTypography tag="strong" className={styles.title}>
                    {title}
                </CardTitleTypography>
            ) : null}
            {price !== null ? (
                <SurtitleTypography tag="span" className={styles.price}>
                    {price.toFixed(2)} $
                </SurtitleTypography>
            ) : null}
            <span className={styles.button}>Acheter</span>
        </VerticalCard>
    );
}

export default BlockDefaultCard;
